module.exports = __webpack_public_path__ + "assets/img/组 151@2x.55c2821b.png";